/**
 * SpecialExamsEnroll scene
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */

import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import * as selectors from './logic/selectors';

import { actions } from 'store/rootSlices';
import config from 'config';

import PageStructure from 'shared/containers/PageStructure';
import Header from 'shared/containers/TitleHeader';
import styled from 'styled-components';
import { Card, CallToAction, Text } from '@paco_ua/pacoui';
import { usePostMessageMiddleware } from 'shared/components/ModuleCommunication';
import { CommunicationTypes } from 'shared/components/ModuleCommunication/communicationTypes';
import { IDebitData } from 'scenes/VirtualSecretary/Payments/types';

const SpecialExamsEnroll = ({ t }) => {
  const { onMount, onUnmount } = actions.SpecialExams;
  const { setPreSelectedDebits, setSelectedDebits } = actions.Payments;
  const { navigateTo } = actions.App;
  const { showToaster } = actions.Toaster;

  const dispatch = useDispatch();
  const { loading } = useSelector(selectors.getSpecialExamsSlice);
  const user = useSelector(selectors.getUser);

  const currentLocale = useSelector(selectors.getCurrentLocale);
  const [iframeReady, setIframeReady] = useState(false);

  const onIframeLoad = () => {
    setIframeReady(true);
  };

  //iframe
  const [embeddedModuleLoaded, setEmbeddedModuleLoaded] = useState(false);
  const [embeddedModuleHeight, setEmbeddedModuleHeight] = useState(0);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  //trying middleware
  const {
    addMessageListener,
    cleanup,
    sendMessage,
    removeMessageListener,
  } = usePostMessageMiddleware(iframeRef.current?.contentWindow, config.IFRAME_ENROLL);

  const loadModule = async () => {
    setEmbeddedModuleLoaded(true);
  };

  useEffect(() => {
    const iframeElement = iframeRef.current;

    if (iframeElement) {
      iframeElement.addEventListener('load', loadModule);
    }

    return () => {
      if (iframeElement) {
        iframeElement.removeEventListener('load', loadModule);
      }
    };
  }, []);

  useEffect(() => {
    sendMessage(CommunicationTypes.STORE_OTHER_ACTION, user);
  }, [user, embeddedModuleLoaded]);

  useEffect(() => {
    sendMessage(CommunicationTypes.CHANGE_LANG, { lang: currentLocale });
  }, [currentLocale, embeddedModuleLoaded]);

  useEffect(() => {
    //here we define the handler for this type (STORE_TOASTER_ACTION) of message
    addMessageListener(CommunicationTypes.STORE_TOASTER_ACTION, (payload) => {
      dispatch(showToaster(payload));
    });

    //here we define the handler for this type (STORE_TOASTER_ACTION) of message
    addMessageListener(CommunicationTypes.IFRAME_HEIGHT, (payload) => {
      console.log(payload.height);
      setEmbeddedModuleHeight(Number(payload.height) ?? 0);
    });

    addMessageListener(CommunicationTypes.STORE_NAVIGATE_ACTION, (payload) => {
      dispatch(actions.App.navigateTo(payload));
    });

    addMessageListener(CommunicationTypes.STORE_OTHER_ACTION, (payload) => {
      if (payload && payload.type == 'changeStore' && payload.data) {
        const { enrollmentsDetails, selectedRegistrationId } = payload.data;
        const enrollmentsPaymentData = [enrollmentsDetails] as IDebitData[];

        dispatch(setPreSelectedDebits(enrollmentsPaymentData));
        dispatch(setSelectedDebits(enrollmentsPaymentData));
        dispatch(navigateTo({ key: 'pendingDebitsPayment', state: 302254 })); // hardcoded: selectedRegistrationId to test
      }
    });

    sendMessage(CommunicationTypes.STORE_OTHER_ACTION, user);
    sendMessage(CommunicationTypes.STORE_NAVIGATE_ACTION, { key: '/especial' });

    return () => {
      removeMessageListener(CommunicationTypes.STORE_NAVIGATE_ACTION);
      removeMessageListener(CommunicationTypes.STORE_OTHER_ACTION);
      removeMessageListener(CommunicationTypes.STORE_OTHER_ACTION);
    };
  }, [embeddedModuleLoaded]);

  useEffect(() => {
    dispatch(onMount());
    return () => {
      dispatch(onUnmount());
    };
  }, [dispatch, onMount, onUnmount]);

  return (
    <PageStructure
      loading={loading}
      expanded={true}
      mainContent={
        <ContentWrapper>
          <iframe
            title="enrollments"
            src={config.IFRAME_ENROLL}
            ref={iframeRef}
            width="100%"
            height={embeddedModuleHeight}
            frameBorder="0"
          ></iframe>
        </ContentWrapper>
      }
    />
  );
};
const Wrapper = styled.div`
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // to compensate PageStructure default margin-top
  margin-top: -20px;
`;

export default SpecialExamsEnroll;
